
<template>
    <div>
        <video-index-items :key="$route?.params?.slug" />
    </div>
</template>



<script>
import VideoIndexItems from "@/components/video/VideoIndexItems";

export default {
    components: {
        VideoIndexItems,
    },
};
</script>
